var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { InputAdornment, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import FTLIconButton from "../buttons/FTLIconButton";
import ChevronIcon from "../icons/Chevron";
import ClearIcon from "../icons/Clear";
import FTLDots from "../loaders/FTLDots";
import FTLTextField from "./FTLTextField";
const useStyles = makeStyles((theme) => ({
    iconWrapper: ({ size, }) => ({
        display: "flex",
        alignItems: "center",
        marginRight: size === "small" ? -4 : 0,
    }),
    startAdornment: {
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        height: "100%",
        maxHeight: "none",
        padding: "6px 0",
    },
    clearIndicator: ({ size, }) => ({
        marginRight: size === "medium" ? 4 : 0,
        "& svg": {
            fill: theme.palette.icon.tertiary,
            "&:hover": {
                fill: theme.palette.icon.secondary,
            },
        },
    }),
    input: ({ readOnly }) => ({
        "& .MuiInputBase-input, & .MuiInputBase-root": {
            cursor: readOnly ? "pointer !important" : undefined,
        },
    }),
    hideInput: {
        "& .MuiInputBase-input": {
            padding: 0,
            width: 0,
            color: "transparent",
        },
    },
    loader: {
        marginRight: 4,
    },
}));
export default React.forwardRef((_a, ref) => {
    var { hideInput, hideLoader, hasValue, clearProps, clearable = true, popupIndicatorProps, popupOpen, InputProps, children, loading, clearText = "Очистить", closeText = "Закрыть", openText = "Открыть", disabled, readOnly, size = "medium", onPopupIndicatorClick, popupIndicatorIcon = (React.createElement(ChevronIcon, { direction: popupOpen ? "top" : "bottom", sizeRatio: size === "small" ? 1 : 1.2 })), clearIcon = React.createElement(ClearIcon, { sizeRatio: size === "small" ? 0.83 : 1 }), value = "", variant = "default", inputVariant } = _a, props = __rest(_a, ["hideInput", "hideLoader", "hasValue", "clearProps", "clearable", "popupIndicatorProps", "popupOpen", "InputProps", "children", "loading", "clearText", "closeText", "openText", "disabled", "readOnly", "size", "onPopupIndicatorClick", "popupIndicatorIcon", "clearIcon", "value", "variant", "inputVariant"]);
    const classes = useStyles({ readOnly, size });
    return (React.createElement(FTLTextField, Object.assign({}, props, { ref: ref, className: clsx(hideInput ? classes.hideInput : undefined, classes.input), value: value, focused: popupOpen, variant: inputVariant, autoComplete: "off", autoCapitalize: "none", role: "combobox", size: size, InputProps: Object.assign(Object.assign({}, InputProps), { disabled, endAdornment: (React.createElement(InputAdornment, { position: "end", className: classes.iconWrapper },
                loading && !hideLoader && !popupOpen && (React.createElement(FTLDots, { className: classes.loader, color: "tertiary" })),
                hasValue && clearable && !disabled && (React.createElement(FTLIconButton, Object.assign({ size: "small", className: classes.clearIndicator }, clearProps, { "aria-label": clearText, title: clearText }), clearIcon)),
                (variant === "default" || !hasValue || !clearable) && (React.createElement(FTLIconButton, Object.assign({ size: "small", color: "secondary" }, popupIndicatorProps, { disabled: disabled, "aria-label": popupOpen ? closeText : openText, title: popupOpen ? closeText : openText, tabIndex: -1, onClick: onPopupIndicatorClick }), popupIndicatorIcon)))), startAdornment: children && (React.createElement(InputAdornment, { position: "start", className: classes.startAdornment }, children)), readOnly }) })));
});
//# sourceMappingURL=FTLSelectControl.js.map